import createController from './collection/create-controller';
import mapDispatchToProps from './collection/map-dispatch-to-props';
import createStoreSelector from './collection/create-store-selector';
import createTransform from './collection/create-transform';
import createStateGetter from './collection/create-state-getter';
import { selectResource } from './resource-entity';

export default (Collection, Entity, ctrl = {}, options = {}) => {
  let { selectEntities } = options;

  if (typeof selectEntities !== 'function') {
    selectEntities = entities => entities;

    // eslint-disable-next-line
    // console.warn(`${Collection.name} is using the default selectEntities function. This will return all ${Entity.name} entities in the store.`);
  }

  if (typeof ctrl.runOperation !== 'function') {
    throw new Error(`Missing runOperation method for ${Collection.name}`);
  }

  const controller = {
    mapDispatchToProps,
    storeSelector: createStoreSelector(Collection, Entity, selectEntities, selectResource),
    transform: createTransform(Collection, ctrl),
    getState: createStateGetter(Collection),
  };

  Object.assign(controller, ctrl);

  return createController(Collection, Entity, controller);
};
